import { type ActivityStatus } from 'connect-graphql/generated';

export interface StatusSlot {
  dueDate?: Date;
  score?: null | number;
  status: ActivityStatus;
  userIds?: string[];
}

export interface ProgressSlot {
  approved: number;
  pending: number;
  returned?: number;
}

/**
 * Checks if the provided object is a StatusSlot by verifying the presence of 'status' property.
 *
 * @param {object} props The object to check for being a StatusSlot.
 *
 * @returns {boolean} Indicates if the object is a StatusSlot.
 */
export function isStatusSlot(props: object): props is StatusSlot {
  return 'status' in props;
}

/**
 * Checks if the provided object is a ProgressSlot by verifying the presence of 'approved' and
 * 'pending' properties.
 *
 * @param {object} props The object to check for being a ProgressSlot.
 *
 * @returns {boolean} Indicates if the object is a ProgressSlot.
 */
export function isProgressSlot(props: object): props is ProgressSlot {
  return 'approved' in props && 'pending' in props;
}
